module.exports = __webpack_public_path__ + "static/media/innova2.679ec0c7.jpg";